// RODO Store — header / mobile nav
document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('nav-toggle');
    var drawer = document.getElementById('mobile-nav');
    if (!toggle || !drawer) return;

    function setOpen(open) {
        toggle.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
            drawer.removeAttribute('hidden');
        } else {
            drawer.setAttribute('hidden', '');
        }
    }

    toggle.addEventListener('click', function () {
        var isOpen = toggle.classList.contains('is-open');
        setOpen(!isOpen);
    });

    // Close after picking a link
    drawer.addEventListener('click', function (e) {
        if (e.target.tagName === 'A') setOpen(false);
    });

    // Close on resize to desktop
    window.addEventListener('resize', function () {
        if (window.getComputedStyle(toggle).display === 'none') setOpen(false);
    });
});

// Load the Tally embed only when a visitor opens the quiz.
document.addEventListener('click', function (event) {
    var resetButton = event.target.closest('[data-rs-quiz-reset]');
    if (resetButton) {
        var resetPanel = document.getElementById(resetButton.getAttribute('aria-controls'));
        var resetIframe = resetPanel ? resetPanel.querySelector('iframe[data-tally-src]') : null;
        if (resetIframe) {
            var tallyUrl = resetIframe.dataset.tallySrc;
            resetIframe.style.height = '';
            resetIframe.height = '310';
            resetIframe.src = 'about:blank';
            window.requestAnimationFrame(function () {
                resetIframe.src = tallyUrl;
            });
        }
        return;
    }

    var button = event.target.closest('[data-rs-quiz-toggle]');
    if (!button) return;

    var widget = button.closest('[data-rs-quiz]');
    if (!widget) return;

    var panelId = button.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    var iframe = panel ? panel.querySelector('iframe[data-tally-src]') : null;
    if (!panel || !iframe) return;

    var isOpening = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', isOpening ? 'true' : 'false');
    button.textContent = isOpening ? 'Ukryj quiz' : 'Uruchom quiz';
    panel.hidden = !isOpening;
    widget.querySelector('[data-rs-quiz-reset]').hidden = !isOpening;

    if (!isOpening) return;

    if (window.Tally) {
        window.Tally.loadEmbeds();
        return;
    }

    if (document.querySelector('script[data-rs-tally-loader]')) return;

    var script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.dataset.rsTallyLoader = 'true';
    script.onload = function () {
        if (window.Tally) {
            window.Tally.loadEmbeds();
        } else if (!iframe.src) {
            iframe.src = iframe.dataset.tallySrc;
        }
    };
    script.onerror = function () {
        if (!iframe.src) iframe.src = iframe.dataset.tallySrc;
    };
    document.body.appendChild(script);
});
